"use client";
import { usePathname, useSearchParams } from "next/navigation";
import { useCallback, useEffect, useMemo, } from "react";

import useStore from "../../../lib/Store/useStore";
import { getPathSpecificCountryData } from "./constants.js";
import { fetchGeoLocation } from "../../../lib/User/IP2LocationApi";
import { getAuthSession } from "@/lib/User/action";

const MobileCurrencySelectorHook = () => {
    const searchParams = useSearchParams();
    const pathName = usePathname();
    const {
        flag,
        countriesRates,
        changeCurrency,
        getCountriesList,
        hasCountryHydrated,
        showCountrySelectionPopUp,
    } = useStore();


    const isSaudia = searchParams.get("sa");

    const pathSpecificCountryData = useMemo(
        () => getPathSpecificCountryData(pathName),
        [pathName]
    );



    // Memoize the function that sets the country
    const setCountry = useCallback(async (country_code) => {
        let countriesWithExchangeRate = countriesRates
        // if (!countriesWithExchangeRate?.length) {
        //     countriesWithExchangeRate = await getCountriesList()
        // }
        const filterData = countriesWithExchangeRate?.find(
            (country) => country?.iso_alpha_2 === country_code
        );
        if (!filterData) return;

        const data = {
            country: filterData?.country,
            flag: filterData?.iso_alpha_2,
            currency: filterData?.code,
            price: filterData?.subscription_rate,
            exchangeRate: filterData?.exchangeRate
        };
        changeCurrency(data);
    }, []);

    // Memoize the function to fetch user location, so it doesn't re-run unnecessarily
    const getUserLocation = useCallback(async () => {
        if (flag || pathSpecificCountryData?.flag) {
            //Prefer path-specific-flag over flag
            setCountry(pathSpecificCountryData?.flag || flag);
            return;
        }

        showCountrySelectionPopUp(true);
        const result = await fetchGeoLocation();
        setCountry(result?.country_code);
    }, [
        flag,
        pathSpecificCountryData?.flag,
        showCountrySelectionPopUp,
    ]);

    // Run effect based on certain conditions
    useEffect(() => {
        const setCountryFlag = async () => {
            const authAession = await getAuthSession()
            if (authAession?.user?.countryCode) {
                setCountry(authAession.user.countryCode);
            } else if (isSaudia) {
                setCountry("SA");
            } else {
                getUserLocation(); // Fetch user location if no flag or pathSpecificCountryData
            }
        }
        if (hasCountryHydrated && !flag) setCountryFlag()
    }, [isSaudia, pathSpecificCountryData, hasCountryHydrated, flag]);

    return (
        <></ >
    );
};

export default MobileCurrencySelectorHook;
